// Helper function to get the full image URL
// Handles both relative paths (/api/uploads/...) and absolute URLs (https://...)

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const getImageUrl = (url) => {
  if (!url) return '';
  
  // If it's already an absolute URL, return as is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  
  // If it's a relative URL starting with /api/uploads, prepend backend URL
  if (url.startsWith('/api/uploads/')) {
    return `${BACKEND_URL}${url}`;
  }
  
  // If it's just a filename, assume it's in uploads
  if (!url.includes('/')) {
    return `${BACKEND_URL}/api/uploads/${url}`;
  }
  
  // Default: prepend backend URL
  return `${BACKEND_URL}${url}`;
};

export default getImageUrl;
